import styled from 'styled-components';
import theme from 'common/theme';

interface LineRunningStatusWidgetContainerProps {
    borderColor?: string;
}

export const LineRunningStatusWidgetContainer = styled.div<LineRunningStatusWidgetContainerProps>`
    padding: 1.3rem;
    border-radius: 10px;
    border: 1px solid var(--Color-Status-Error, #B30000);
    background: var(--Color-Brand-color-White, #FFF);
    border: 1px solid ${({ borderColor }) => borderColor || theme.colors.gray300};
    display: flex;
    flex-direction: column;
    gap: 1rem;
    height: fit-content;
    width: 250px;
    flex: 0 0 250px;

    .line-running-status-widget__title {
        display: flex;
        align-items: center;
        gap: 0.5rem;
        .line-running-status-widget__title-text {
            color: var(--Grey-Scale-Grey-800, var(--Color-Gray-800, #323130));
            font-size: 0.875rem;
            font-style: normal;
            font-weight: 600;
            line-height: normal;
            color: ${theme.colors.gray800};
        }
    }
    .gauge-chart-container {
        position: relative;
        width: 100%;
        height: 120px;
        .guage-chart {
            position: absolute;
            top: 10%;
            left: 50%;
            transform: translate(-50%, -50%);
        }
    }
`;
